<template>
  <div>
    <b-container variant="primary" fluid class="p-5">
      <b-row>
        <b-col :cols="12">
          <h3>Editar cliente</h3>
          <!-- Form -->
          <b-form @submit.stop.prevent="onSubmit">
            <b-alert :show="form.error.show" variant="danger">{{
              form.error.text
            }}</b-alert>

            <!-- <h4>Características</h4> -->

            <b-form-row>
              <!-- Nombre -->
              <b-form-group
                id="input-full_name"
                class="col-6"
                label="Nombre y Apellidos / Razón Social"
                label-for="full_name"
              >
                <b-form-input
                  id="full_name"
                  v-model="$v.form.full_name.$model"
                  :state="validateState('full_name')"
                  aria-describedby="input-full_name-feedback"
                ></b-form-input>
                <b-form-invalid-feedback id="input-full_name-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>

              <!-- Apellidos -->
              <b-form-group
                id="input-person_of_contact"
                class="col-6"
                label="Persona de Contacto"
                label-for="person_of_contact"
              >
                <b-form-input
                  id="person_of_contact"
                  v-model="$v.form.person_of_contact.$model"
                  :state="validateState('person_of_contact')"
                  aria-describedby="input-person_of_contact-feedback"
                ></b-form-input>
                <b-form-invalid-feedback id="input-person_of_contact-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>

              <b-form-group
                id="input-phone_number"
                class="col-3"
                label="Teléfono Cliente"
                label-for="phone_number"
              >
                <b-form-input
                  id="phone_number"
                  v-model="$v.form.phone_number.$model"
                  :state="validateState('phone_number')"
                  aria-describedby="input-phone_number-feedback"
                ></b-form-input>
                <b-form-invalid-feedback
                  v-if="!$v.form.phone_number.phone_number"
                  id="input-phone_number-feedback"
                  >Debe ser un correo electrónico
                  válido.</b-form-invalid-feedback
                >
                <b-form-invalid-feedback v-else id="input-phone_number-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>

              <b-form-group
                id="input-email"
                class="col-3"
                label="Email Cliente"
                label-for="email"
              >
                <b-form-input
                  id="email"
                  v-model="$v.form.email.$model"
                  :state="validateState('email')"
                  aria-describedby="input-email-feedback"
                ></b-form-input>
                <b-form-invalid-feedback
                  v-if="!$v.form.email.email"
                  id="input-email-feedback"
                  >Debe ser un correo electrónico
                  válido.</b-form-invalid-feedback
                >
                <b-form-invalid-feedback v-else id="input-email-feedback"
                  >Obligatorio (no se pueden eliminar emails informados, sólo
                  modificarlos).</b-form-invalid-feedback
                >
              </b-form-group>

              <b-form-group
                id="input-phone_number_person_of_contact"
                class="col-3"
                label="Teléfono Persona Contacto"
                label-for="phone_number_person_of_contact"
              >
                <b-form-input
                  id="phone_number_person_of_contact"
                  v-model="$v.form.phone_number_person_of_contact.$model"
                  :state="validateState('phone_number_person_of_contact')"
                  aria-describedby="input-phone_number_person_of_contact-feedback"
                ></b-form-input>
              </b-form-group>

              <b-form-group
                id="input-email_person_of_contact"
                class="col-3"
                label="Email Persona Contacto"
                label-for="email_person_of_contact"
              >
                <b-form-input
                  id="email_person_of_contact"
                  v-model="$v.form.email_person_of_contact.$model"
                  :state="validateState('email_person_of_contact')"
                  aria-describedby="input-email_person_of_contact-feedback"
                ></b-form-input>
                <b-form-invalid-feedback
                  v-if="!$v.form.email_person_of_contact.email"
                  id="input-email_person_of_contact-feedback"
                  >Debe ser un correo electrónico
                  válido.</b-form-invalid-feedback
                >
              </b-form-group>

              <b-form-group
                id="input-default_discount"
                class="col-3"
                label="Descuento Por Defecto"
                description="Se mostrará a la hora de crear un presupuesto para este cliente."
                label-for="default_discount"
              >
                <b-input-group>
                  <b-form-input
                    id="default_discount"
                    :value="$v.form.default_discount.$model.replace('.', ',')"
                    @change="setDecimal('default_discount', $event)"
                    :state="validateState('default_discount')"
                    aria-describedby="input-default_discount-feedback"
                  ></b-form-input>
                  <template #append>
                    <b-input-group-text>%</b-input-group-text>
                  </template>
                </b-input-group>

                <b-form-invalid-feedback id="input-default_discount-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>

              <b-form-group
                id="shipping-comms_lang"
                class="col-3"
                label="Idioma Comunicaciones"
                label-for="comms_lang"
              >
                <b-form-select
                  :options="languageOptions"
                  id="comms_lang"
                  v-model="$v.form.comms_lang.$model"
                  :state="validateState('comms_lang')"
                  aria-describedby="shipping-comms_lang-feedback"
                ></b-form-select>
                <b-form-invalid-feedback id="shipping-comms_lang-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>

              <b-form-group
                id="shipping-gender"
                class="col-3"
                label="Género"
                label-for="gender"
              >
                <b-form-select
                  :options="genderOptions"
                  id="gender"
                  v-model="$v.form.gender.$model"
                  :state="validateState('gender')"
                  aria-describedby="shipping-gender-feedback"
                ></b-form-select>
                <b-form-invalid-feedback id="shipping-gender-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>

              <b-form-group
                id="input-opted_in_commercial"
                class="col-3"
                label="Comunicaciones Comerciales"
                label-for="opted_in_commercial"
              >
                <b-form-checkbox
                  switch
                  v-model="$v.form.opted_in_commercial.$model"
                  name="input-opted_in_commercial"
                  >{{
                    $v.form.opted_in_commercial.$model ? 'Sí' : 'No'
                  }}</b-form-checkbox
                >
              </b-form-group>
              <!-- <b-form-group
                id="customer-input-company_name"
                class="col-3"
                label="Nombre empresa"
                label-for="customer-company_name"
              >
                <b-form-input
                  id="customer-company_name"
                  v-model="$v.form.company_name.$model"
                  :state="validateState('company_name')"
                  aria-describedby="customer-input-company_name-feedback"
                ></b-form-input>
              </b-form-group> -->

              <!-- <b-form-group
                id="customer-input-company_id"
                class="col-3"
                label="CIF/NIF"
                label-for="customer-company_id"
              >
                <b-form-input
                  id="customer-company_id"
                  v-model="$v.form.company_id.$model"
                  :state="validateState('company_id')"
                  aria-describedby="customer-input-company_id-feedback"
                ></b-form-input>
              </b-form-group> -->

              <!-- <b-form-group
                id="shipping-comms_lang"
                class="col-3"
                label="Idioma comunicaciones"
                label-for="comms_lang"
              >
                <b-form-select
                  :options="languageOptions"
                  id="comms_lang"
                  v-model="$v.form.comms_lang.$model"
                  :state="validateState('comms_lang')"
                  aria-describedby="shipping-comms_lang-feedback"
                ></b-form-select>
                <b-form-invalid-feedback id="shipping-comms_lang-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>

              <b-form-group
                id="shipping-gender"
                class="col-3"
                label="Género"
                label-for="gender"
              >
                <b-form-select
                  :options="genderOptions"
                  id="gender"
                  v-model="$v.form.gender.$model"
                  :state="validateState('gender')"
                  aria-describedby="shipping-gender-feedback"
                ></b-form-select>
                <b-form-invalid-feedback id="shipping-gender-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group> -->

              <!-- <b-form-group
                id="customer-input-street_address"
                class="col-3"
                label="Dirección postal"
                label-for="customer-street_address"
              >
                <b-form-input
                  id="customer-street_address"
                  v-model="$v.form.street_address.$model"
                  :state="validateState('street_address')"
                  aria-describedby="customer-input-street_address-feedback"
                ></b-form-input>
              </b-form-group>

              <b-form-group
                id="customer-input-postal_code"
                class="col-3"
                label="Código postal"
                label-for="customer-postal_code"
              >
                <b-form-input
                  id="customer-postal_code"
                  v-model="$v.form.postal_code.$model"
                  :state="validateState('postal_code')"
                  aria-describedby="customer-input-postal_code-feedback"
                ></b-form-input>
              </b-form-group>

              <b-form-group
                id="customer-city-name"
                class="col-3"
                label="Ciudad"
                label-for="customer-city"
              >
                <b-form-input
                  id="customer-city"
                  v-model="$v.form.city.$model"
                  :state="validateState('city')"
                  aria-describedby="customer-input-city-feedback"
                ></b-form-input>
              </b-form-group>

              <b-form-group
                id="customer-input-country"
                class="col-3"
                label="País"
                label-for="customer-country"
              >
                <b-form-select
                  :options="countries"
                  id="customer-country"
                  v-model="$v.form.country.$model"
                  :state="validateState('country')"
                  aria-describedby="customer-input-country-feedback"
                ></b-form-select>
                <b-form-invalid-feedback id="customer-input-country-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group> -->

              <!-- <b-form-group
                id="input-opted_in_commercial"
                class="col-6"
                label="Comunicaciones comerciales"
                label-for="opted_in_commercial"
              >
                <b-form-checkbox
                  switch
                  v-model="$v.form.opted_in_commercial.$model"
                  name="input-opted_in_commercial"
                  >{{
                    $v.form.opted_in_commercial.$model ? 'Sí' : 'No'
                  }}</b-form-checkbox
                >
              </b-form-group> -->
            </b-form-row>

            <!-- <h5>Descuentos</h5> -->

            <b-row class="mt-4">
              <b-col cols="6">
                <h5>
                  Direcciones de facturación
                  <b-button
                    v-if="id !== 'new'"
                    class="ml-1"
                    size="sm"
                    variant="outline-secondary"
                    :to="{
                      name: 'AdminInvoicesCustomerScreen',
                      params: { customerid: id },
                    }"
                    >Ver facturas</b-button
                  >
                </h5>

                <b-card no-body>
                  <b-tabs card ref="billing-tabs">
                    <!-- Render Tabs, supply a unique `key` to each tab -->
                    <b-tab
                      :ref="'billing-address-' + i"
                      v-for="(v, i) in $v.form.billingAddresses.$each.$iter"
                      :key="'billing-address-' + i"
                      :title="v.name.$model"
                    >
                      <!-- <b-button
                        class="float-right"
                        @click="copyCustomerInfoIntoBilling(i)"
                        size="sm"
                        >Copiar datos cliente</b-button
                      > -->
                      <b-form-row>
                        <b-form-group
                          id="billing-input-name"
                          class="col-6"
                          label="Nombre de la Dirección de Facturación"
                          label-for="billing-name"
                        >
                          <b-form-input
                            id="billing-name"
                            v-model="v.name.$model"
                            :state="validateStateBillingAddress(i, 'name')"
                            aria-describedby="billing-input-name-feedback"
                          ></b-form-input>

                          <b-form-invalid-feedback
                            v-if="!v.name.required"
                            id="billing-input-country-feedback"
                            >Este campo es obligatorio.</b-form-invalid-feedback
                          >
                          <b-form-invalid-feedback
                            v-if="!v.name.notUsedBillingName"
                            id="billing-input-country-feedback"
                            >No puede coincidir con el nombre de otro
                            contacto.</b-form-invalid-feedback
                          >
                        </b-form-group>
                      </b-form-row>

                      <hr />

                      <b-form-row>
                        <b-form-group
                          id="billing-input-full_name"
                          class="col-6"
                          label="Nombre y Apellidos / Razón Social"
                          label-for="billing-full_name"
                        >
                          <b-form-input
                            id="billing-full_name"
                            v-model="v.full_name.$model"
                            :state="validateStateBillingAddress(i, 'full_name')"
                            aria-describedby="billing-input-full_name-feedback"
                          ></b-form-input>
                          <b-form-invalid-feedback
                            id="billing-input-full_name-feedback"
                            >Este campo es obligatorio.</b-form-invalid-feedback
                          >
                        </b-form-group>

                        <b-form-group
                          id="billing-input-company_id"
                          class="col-6"
                          label="CIF/NIF"
                          label-for="billing-company_id"
                        >
                          <b-form-input
                            id="billing-company_id"
                            v-model="v.company_id.$model"
                            :state="
                              validateStateBillingAddress(i, 'company_id')
                            "
                            aria-describedby="billing-input-company_id-feedback"
                          ></b-form-input>
                        </b-form-group>

                        <!-- <b-form-group
                          id="billing-input-last_name"
                          class="col-6"
                          label="Apellidos"
                          label-for="billing-last_name"
                        >
                          <b-form-input
                            id="billing-last_name"
                            v-model="v.last_name.$model"
                            :state="validateStateBillingAddress(i, 'last_name')"
                            aria-describedby="billing-input-last_name-feedback"
                          ></b-form-input>
                        </b-form-group> -->
                      </b-form-row>

                      <b-form-row>
                        <b-form-group
                          id="billing-input-street_address"
                          class="col-12"
                          label="Dirección Postal"
                          label-for="billing-street_address"
                        >
                          <b-form-input
                            id="billing-street_address"
                            v-model="v.street_address.$model"
                            :state="
                              validateStateBillingAddress(i, 'street_address')
                            "
                            aria-describedby="billing-input-street_address-feedback"
                          ></b-form-input>
                          <b-form-invalid-feedback
                            id="billing-input-street_address-feedback"
                            >Este campo es obligatorio.</b-form-invalid-feedback
                          >
                        </b-form-group>
                        <b-form-group class="col-12">
                          <GoogleAutocomplete
                            @address-selected="
                              handleAddressSelectedBilling(i, $event)
                            "
                          />
                        </b-form-group>
                      </b-form-row>

                      <b-form-row>
                        <b-form-group
                          id="billing-input-street_address_2"
                          class="col-6"
                          label="Bloque, Piso, Puerta"
                          label-for="billing-street_address_2"
                        >
                          <b-form-input
                            id="billing-street_address_2"
                            v-model="v.street_address_2.$model"
                            :state="
                              validateStateBillingAddress(i, 'street_address_2')
                            "
                            aria-describedby="billing-input-street_address_2-feedback"
                          ></b-form-input>
                        </b-form-group>

                        <b-form-group
                          id="billing-input-urbanization"
                          class="col-6"
                          label="Urbanización"
                          label-for="billing-urbanization"
                        >
                          <b-form-input
                            id="billing-urbanization"
                            v-model="v.urbanization.$model"
                            :state="
                              validateStateBillingAddress(i, 'urbanization')
                            "
                            aria-describedby="billing-input-urbanization-feedback"
                          ></b-form-input>
                        </b-form-group>
                      </b-form-row>

                      <b-form-row>
                        <b-form-group
                          id="billing-city-name"
                          class="col-6"
                          label="Localidad"
                          label-for="billing-city"
                        >
                          <b-form-input
                            id="billing-city"
                            v-model="v.city.$model"
                            :state="validateStateBillingAddress(i, 'city')"
                            aria-describedby="billing-input-city-feedback"
                          ></b-form-input>
                          <b-form-invalid-feedback
                            id="billing-input-city-feedback"
                            >Este campo es obligatorio.</b-form-invalid-feedback
                          >
                        </b-form-group>

                        <b-form-group
                          id="billing-input-postal_code"
                          class="col-6"
                          label="Código Postal"
                          label-for="billing-postal_code"
                        >
                          <b-form-input
                            id="billing-postal_code"
                            v-model="v.postal_code.$model"
                            :state="
                              validateStateBillingAddress(i, 'postal_code')
                            "
                            aria-describedby="billing-input-postal_code-feedback"
                          ></b-form-input>
                          <b-form-invalid-feedback
                            id="billing-input-postal_code-feedback"
                            >Este campo es obligatorio.</b-form-invalid-feedback
                          >
                        </b-form-group>
                      </b-form-row>
                      <b-form-row>
                        <b-form-group
                          id="billing-state-name"
                          class="col-6"
                          label="Provincia"
                          label-for="billing-state"
                        >
                          <b-form-input
                            id="billing-state"
                            v-model="v.state.$model"
                            :state="validateStateBillingAddress(i, 'state')"
                            aria-describedby="billing-input-state-feedback"
                          ></b-form-input>
                        </b-form-group>

                        <b-form-group
                          id="billing-region-name"
                          class="col-6"
                          label="Región / Comunidad autónoma / Estado"
                          label-for="billing-region"
                        >
                          <b-form-input
                            id="billing-region"
                            v-model="v.region.$model"
                            :region="validateStateBillingAddress(i, 'region')"
                            aria-describedby="billing-input-region-feedback"
                          ></b-form-input>
                        </b-form-group>
                      </b-form-row>

                      <b-form-row>
                        <b-form-group
                          id="billing-input-country"
                          class="col-6"
                          label="País"
                          label-for="billing-country"
                        >
                          <b-form-select
                            :options="countries"
                            id="billing-country"
                            v-model="v.country.$model"
                            :state="validateStateBillingAddress(i, 'country')"
                            aria-describedby="billing-input-country-feedback"
                          ></b-form-select>
                          <b-form-invalid-feedback
                            id="billing-input-country-feedback"
                            >Este campo es obligatorio.</b-form-invalid-feedback
                          >
                        </b-form-group>
                      </b-form-row>

                      <!-- <b-form-row>
                        <b-form-group
                          id="billing-input-company_name"
                          class="col-6"
                          label="Nombre empresa"
                          label-for="billing-company_name"
                        >
                          <b-form-input
                            id="billing-company_name"
                            v-model="v.company_name.$model"
                            :state="
                              validateStateBillingAddress(i, 'company_name')
                            "
                            aria-describedby="billing-input-company_name-feedback"
                          ></b-form-input>
                        </b-form-group>
                      </b-form-row> -->

                      <!-- <b-form-row>
                        <b-form-group
                          id="billing-input-phone_number"
                          class="col-6"
                          label="Teléfono"
                          description="Sólo se utiliza en presupuestos con dirección de facturación (para que este contenga los datos identificativos de esta dirección en lugar del cliente)"
                          label-for="billing-phone_number"
                        >
                          <b-form-input
                            id="billing-phone_number"
                            v-model="v.phone_number.$model"
                            :state="
                              validateStateBillingAddress(i, 'phone_number')
                            "
                            aria-describedby="billing-input-phone_number-feedback"
                          ></b-form-input>
                        </b-form-group>

                        <b-form-group
                          id="billing-input-email"
                          class="col-6"
                          description="Sólo se utiliza en presupuestos con dirección de facturación (para que este contenga los datos identificativos de esta dirección en lugar del cliente)"
                          label="Email"
                          label-for="billing-email"
                        >
                          <b-form-input
                            id="billing-email"
                            v-model="v.email.$model"
                            :state="validateStateBillingAddress(i, 'email')"
                            aria-describedby="billing-input-email-feedback"
                          ></b-form-input>
                        </b-form-group>
                      </b-form-row> -->

                      <b-row>
                        <b-col class="mt-3" cols="12">
                          <b-button
                            variant="danger"
                            size="sm"
                            class="float-right"
                            @click="closeTabBilling(i)"
                          >
                            Eliminar contacto de facturación
                          </b-button>
                        </b-col>
                      </b-row>
                    </b-tab>

                    <!-- New Tab Button (Using tabs-end slot) -->
                    <template #tabs-end>
                      <b-nav-item
                        role="presentation"
                        @click.prevent="newTabBilling"
                        href="#"
                        ><b>+</b></b-nav-item
                      >
                    </template>

                    <!-- Render this if no tabs -->
                    <template #empty>
                      <div class="text-center text-muted">
                        Añade una nueva dirección haciendo click en <b>+</b>.
                      </div>
                    </template>
                  </b-tabs>
                </b-card></b-col
              >
              <b-col cols="6">
                <h5>Direcciones de envío</h5>
                <b-card no-body>
                  <b-tabs card>
                    <!-- Render Tabs, supply a unique `key` to each tab -->
                    <b-tab
                      :ref="'shipping-address-' + i"
                      v-for="(v, i) in $v.form.shippingAddresses.$each.$iter"
                      :key="'shipping-address-' + i"
                      :title="v.name.$model"
                    >
                      <!-- <b-button
                        class="float-right"
                        @click="copyCustomerInfoIntoShipping(i)"
                        size="sm"
                        >Copiar datos cliente</b-button
                      > -->
                      <b-form-row class="mt-2">
                        <b-form-group
                          id="shipping-input-name"
                          class="col-6"
                          label="Nombre de la Dirección de Envío"
                          label-for="shipping-name"
                        >
                          <b-form-input
                            id="shipping-name"
                            v-model="v.name.$model"
                            :state="validateStateShippingAddress(i, 'name')"
                            aria-describedby="shipping-input-name-feedback"
                          ></b-form-input>
                        </b-form-group>
                      </b-form-row>

                      <hr />

                      <b-form-row>
                        <b-form-group
                          id="shipping-input-full_name"
                          class="col-12"
                          label="Nombre y Apellidos / Razón Social"
                          label-for="shipping-full_name"
                        >
                          <b-form-input
                            id="shipping-full_name"
                            v-model="v.full_name.$model"
                            :state="
                              validateStateShippingAddress(i, 'full_name')
                            "
                            aria-describedby="shipping-input-full_name-feedback"
                          ></b-form-input>
                          <b-form-invalid-feedback
                            id="shipping-input-full_name-feedback"
                            >Este campo es obligatorio.</b-form-invalid-feedback
                          >
                        </b-form-group>

                        <!-- <b-form-group
                          id="shipping-input-last_name"
                          class="col-6"
                          label="Apellidos"
                          label-for="shipping-last_name"
                        >
                          <b-form-input
                            id="shipping-last_name"
                            v-model="v.last_name.$model"
                            :state="
                              validateStateShippingAddress(i, 'last_name')
                            "
                            aria-describedby="shipping-input-last_name-feedback"
                          ></b-form-input>
                        </b-form-group> -->
                      </b-form-row>

                      <b-form-row>
                        <b-form-group
                          id="shipping-input-street_address"
                          class="col-12"
                          label="Dirección Postal"
                          label-for="shipping-street_address"
                        >
                          <b-form-input
                            id="shipping-street_address"
                            v-model="v.street_address.$model"
                            :state="
                              validateStateShippingAddress(i, 'street_address')
                            "
                            aria-describedby="shipping-input-street_address-feedback"
                          ></b-form-input>
                          <b-form-invalid-feedback
                            id="shipping-input-street_address-feedback"
                            >Este campo es obligatorio.</b-form-invalid-feedback
                          >
                        </b-form-group>
                        <b-form-group class="col-12">
                          <GoogleAutocomplete
                            @address-selected="
                              handleAddressSelectedShipping(i, $event)
                            "
                          />
                        </b-form-group>
                      </b-form-row>
                      <b-form-row>
                        <b-form-group
                          id="shipping-input-street_address_2"
                          class="col-6"
                          label="Bloque, Piso, Puerta"
                          label-for="shipping-street_address_2"
                        >
                          <b-form-input
                            id="shipping-street_address_2"
                            v-model="v.street_address_2.$model"
                            :state="
                              validateStateShippingAddress(
                                i,
                                'street_address_2'
                              )
                            "
                            aria-describedby="shipping-input-street_address_2-feedback"
                          ></b-form-input>
                        </b-form-group>

                        <b-form-group
                          id="shipping-input-urbanization"
                          class="col-6"
                          label="Urbanización"
                          label-for="shipping-urbanization"
                        >
                          <b-form-input
                            id="shipping-urbanization"
                            v-model="v.urbanization.$model"
                            :state="
                              validateStateShippingAddress(i, 'urbanization')
                            "
                            aria-describedby="shipping-input-urbanization-feedback"
                          ></b-form-input>
                        </b-form-group>
                      </b-form-row>

                      <b-form-row>
                        <b-form-group
                          id="shipping-city-name"
                          class="col-6"
                          label="Localidad"
                          label-for="shipping-city"
                        >
                          <b-form-input
                            id="shipping-city"
                            v-model="v.city.$model"
                            :state="validateStateShippingAddress(i, 'city')"
                            aria-describedby="shipping-input-city-feedback"
                          ></b-form-input>
                          <b-form-invalid-feedback
                            id="shipping-input-city-feedback"
                            >Este campo es obligatorio.</b-form-invalid-feedback
                          >
                        </b-form-group>

                        <b-form-group
                          id="shipping-input-postal_code"
                          class="col-6"
                          label="Código Postal"
                          label-for="shipping-postal_code"
                        >
                          <b-form-input
                            id="shipping-postal_code"
                            v-model="v.postal_code.$model"
                            :state="
                              validateStateShippingAddress(i, 'postal_code')
                            "
                            aria-describedby="shipping-input-postal_code-feedback"
                          ></b-form-input>
                          <b-form-invalid-feedback
                            id="shipping-input-postal_code-feedback"
                            >Este campo es obligatorio.</b-form-invalid-feedback
                          >
                        </b-form-group>
                      </b-form-row>

                      <b-form-row>
                        <b-form-group
                          id="shipping-state-name"
                          class="col-6"
                          label="Provincia"
                          label-for="shipping-state"
                        >
                          <b-form-input
                            id="shipping-state"
                            v-model="v.state.$model"
                            :state="validateStateShippingAddress(i, 'state')"
                            aria-describedby="shipping-input-state-feedback"
                          ></b-form-input>
                        </b-form-group>

                        <b-form-group
                          id="billing-region-name"
                          class="col-6"
                          label="Región / Comunidad autónoma / Estado"
                          label-for="billing-region"
                        >
                          <b-form-input
                            id="billing-region"
                            v-model="v.region.$model"
                            :region="validateStateShippingAddress(i, 'region')"
                            aria-describedby="billing-input-region-feedback"
                          ></b-form-input>
                        </b-form-group>
                      </b-form-row>
                      <b-form-row>
                        <b-form-group
                          id="shipping-input-country"
                          class="col-6"
                          label="País"
                          label-for="shipping-country"
                        >
                          <b-form-select
                            :options="countries"
                            id="shipping-country"
                            v-model="v.country.$model"
                            :state="validateStateShippingAddress(i, 'country')"
                            aria-describedby="shipping-input-country-feedback"
                          ></b-form-select>
                          <b-form-invalid-feedback
                            id="shipping-input-country-feedback"
                            >Este campo es obligatorio.</b-form-invalid-feedback
                          >
                        </b-form-group>
                      </b-form-row>

                      <b-form-row>
                        <b-form-group
                          id="phone_number_1-city-name"
                          class="col-6"
                          label="Teléfono 1"
                          label-for="phone_number_1-city"
                        >
                          <b-form-input
                            id="phone_number_1-city"
                            v-model="v.phone_number_1.$model"
                            :state="
                              validateStateShippingAddress(i, 'phone_number_1')
                            "
                            aria-describedby="phone_number_1-input-city-feedback"
                          ></b-form-input>
                        </b-form-group>

                        <b-form-group
                          id="phone_number_2-city-name"
                          class="col-6"
                          label="Teléfono 2"
                          label-for="phone_number_2-city"
                        >
                          <b-form-input
                            id="phone_number_2-city"
                            v-model="v.phone_number_2.$model"
                            :state="
                              validateStateShippingAddress(i, 'phone_number_2')
                            "
                            aria-describedby="phone_number_2-input-city-feedback"
                          ></b-form-input>
                        </b-form-group>
                      </b-form-row>

                      <b-form-row>
                        <b-form-group
                          id="shipping-input-email_1"
                          class="col-6"
                          label="Email 1"
                          label-for="shipping-email_1"
                        >
                          <b-form-input
                            id="shipping-email_1"
                            v-model="v.email_1.$model"
                            :state="validateStateShippingAddress(i, 'email_1')"
                            aria-describedby="input-email_1-feedback"
                          ></b-form-input>
                          <b-form-invalid-feedback
                            v-if="!v.email_1.email"
                            id="input-email_1-feedback"
                            >Debe ser un correo electrónico
                            válido.</b-form-invalid-feedback
                          >
                        </b-form-group>

                        <b-form-group
                          id="shipping-input-email_2"
                          class="col-6"
                          label="Email 2"
                          label-for="shipping-email_2"
                        >
                          <b-form-input
                            id="shipping-email_2"
                            v-model="v.email_2.$model"
                            :state="validateStateShippingAddress(i, 'email_2')"
                            aria-describedby="input-email_2-feedback"
                          ></b-form-input>
                          <b-form-invalid-feedback
                            v-if="!v.email_2.email"
                            id="input-email_2-feedback"
                            >Debe ser un correo electrónico
                            válido.</b-form-invalid-feedback
                          >
                        </b-form-group>
                      </b-form-row>

                      <b-form-row>
                        <!-- person_of_contact -->
                        <b-form-group
                          id="shipping-input-person_of_contact"
                          class="col-12"
                          label="Persona de Contacto"
                          label-for="shipping-person_of_contact"
                        >
                          <b-form-input
                            id="shipping-person_of_contact"
                            v-model="v.person_of_contact.$model"
                            :state="
                              validateStateShippingAddress(
                                i,
                                'person_of_contact'
                              )
                            "
                            aria-describedby="shipping-input-person_of_contact-feedback"
                          ></b-form-input>
                        </b-form-group>
                      </b-form-row>

                      <b-row>
                        <b-col class="mt-3" cols="12">
                          <b-button
                            variant="danger"
                            size="sm"
                            class="float-right"
                            @click="closeTabShipping(i)"
                          >
                            Eliminar contacto de envío
                          </b-button>
                        </b-col>
                      </b-row>
                    </b-tab>

                    <!-- New Tab Button (Using tabs-end slot) -->
                    <template #tabs-end>
                      <b-nav-item
                        role="presentation"
                        @click.prevent="newTabShipping"
                        href="#"
                        ><b>+</b></b-nav-item
                      >
                    </template>

                    <!-- Render this if no tabs -->
                    <template #empty>
                      <div class="text-center text-muted">
                        Añade una nueva dirección haciendo click en <b>+</b>.
                      </div>
                    </template>
                  </b-tabs>
                </b-card></b-col
              >
            </b-row>

            <b-button class="mt-4" type="submit" variant="primary"
              >Guardar cliente</b-button
            >
          </b-form>
          <!-- /Form -->
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import {
  required,
  requiredIf,
  email,
  minLength,
  numeric,
} from 'vuelidate/lib/validators';

import { actions } from '@/admin/api.js';

import GoogleAutocomplete from '@/admin/components/clients/GoogleAutocomplete';

import store from '@/admin/store.js';
import { validationMixin } from 'vuelidate';

import { helpers } from 'vuelidate/lib/validators';

import * as Sentry from '@sentry/browser';

function notUsedBillingName(value) {
  return (
    this.form.billingAddresses.filter((x) => x.name === value).length === 1
  );
}

function notUsedShippingName(value) {
  return (
    this.form.shippingAddresses.filter((x) => x.name === value).length === 1
  );
}

export default {
  name: 'AdminCustomersEditScreen',
  props: {
    isModal: {
      type: Boolean,
      default: false,
    },
    id: {},
  },
  components: { GoogleAutocomplete },
  mixins: [validationMixin],
  validations() {
    let rules = {
      full_name: {
        required,
      },
      person_of_contact: {},
      email: {
        email,
        required: requiredIf(function (form) {
          return this.originalEmail !== '';

          // return form.email === 7;
        }),
      },
      email_person_of_contact: {
        email,
      },
      comms_lang: { required },
      gender: { required },
      street_address: {},
      postal_code: {},
      city: {},
      country: {},
      company_name: {},
      company_id: {},
      opted_in_commercial: {
        required,
      },

      default_discount: {
        required,
      },
      phone_number: {},
      phone_number_person_of_contact: {},
      billingAddresses: {
        minLength: minLength(1),
        $each: {
          name: { required, notUsedBillingName },
          full_name: { required },
          street_address: { required },
          street_address_2: {},
          urbanization: {},
          postal_code: { required },
          city: { required },
          country: { required },
          state: {},
          region: {},
          // company_name: {},
          company_id: {},
          // phone_number: {},
          // email: {},
        },
      },
      shippingAddresses: {
        minLength: minLength(1),
        $each: {
          name: { required, notUsedShippingName },
          full_name: { required },
          street_address: { required },
          street_address_2: {},
          urbanization: {},
          postal_code: { required },
          city: { required },
          state: {},
          region: {},
          country: { required },
          phone_number_1: {},
          phone_number_2: {},
          email_1: { email },
          email_2: { email },
          person_of_contact: {},
        },
      },
      // password: {
      //   required,
      // },
      // password_confirmation: {
      //   required,
      //   sameAsPassword: sameAs('password'),
      // },
    };

    // this.languageCodes.map((x) => {
    //   rules['name_' + x] = { required };
    // });

    return {
      form: rules,
    };
  },
  data() {
    let form = {
      full_name: '',
      person_of_contact: '',
      email: '',
      email_person_of_contact: '',
      opted_in_commercial: true,
      comms_lang: '',
      gender: 'others',

      street_address: '',
      postal_code: '',
      city: '',
      country: '',
      company_name: '',
      company_id: '',

      phone_number: null,
      phone_number_person_of_contact: null,
      default_discount: '0',

      billingAddresses: [],
      shippingAddresses: [],

      // password: '',
      // password_confirmation: '',
      error: {
        show: false,
        text: '',
      },
    };

    // store.getLanguageCodes().map((x) => {
    //   form['name_' + x] = '';
    // });

    return {
      sharedState: store.state,
      languageCodes: store.getLanguageCodes().filter((x) => x == 'es'),
      languageNames: store.getLanguageNames(),
      form: form,
      originalEmail: '',
      countries: [],
    };
  },
  created() {
    if (this.id !== 'new') {
      actions.getCustomer(this.id).then((x) => {
        const data = x.data;

        this.form.full_name = data.full_name;
        this.form.person_of_contact = data.person_of_contact;
        this.form.email = data.user ? data.user.email : '';
        this.form.email_person_of_contact = data.email_person_of_contact;

        this.originalEmail = this.form.email;
        this.form.phone_number = data.phone_number;
        this.form.phone_number_person_of_contact =
          data.phone_number_person_of_contact;

        this.form.opted_in_commercial = data.opted_in_commercial;
        this.form.comms_lang = data.comms_lang;
        this.form.gender = data.gender;

        this.form.street_address = data.street_address;
        this.form.postal_code = data.postal_code;
        this.form.city = data.city;
        this.form.country = data.country;
        this.form.company_name = data.company_name;
        this.form.company_id = data.company_id;

        this.form.default_discount = data.default_discount;
      });

      actions.getBillingAddressesByCustomer(this.id).then((y) => {
        for (let index = 0; index < y.data.results.length; index++) {
          //this.form.tabs

          const element = y.data.results[index];

          this.form.billingAddresses.push(element);
        }
      });

      actions.getShippingAddressesByCustomer(this.id).then((y) => {
        for (let index = 0; index < y.data.results.length; index++) {
          //this.form.tabs

          const element = y.data.results[index];

          this.form.shippingAddresses.push(element);
        }
      });
    } else {
      // this.newTabBilling();
      // this.newTabShipping();
    }
    actions.getCountriesUnpaginated().then((z) => {
      for (let index = 0; index < z.data.results.length; index++) {
        //this.form.tabs

        const element = z.data.results[index];

        this.countries.push({
          text: element.name_es,
          value: element.code,
          extra: element.code2,
        });
      }
    });
  },
  computed: {
    languageOptions() {
      let langOptions = [];
      for (
        let index = 0;
        index < Object.keys(this.sharedState.languages).length;
        index++
      ) {
        const id = Object.keys(this.sharedState.languages)[index];
        const val = this.sharedState.languages[
          Object.keys(this.sharedState.languages)[index]
        ];
        langOptions.push({ text: val, value: id });
      }

      return langOptions;
    },
    genderOptions() {
      let genderOptions = [];
      for (
        let index = 0;
        index < Object.keys(this.sharedState.genders).length;
        index++
      ) {
        const id = Object.keys(this.sharedState.genders)[index];
        const val = this.sharedState.genders[
          Object.keys(this.sharedState.genders)[index]
        ];
        genderOptions.push({ text: val, value: id });
      }

      return genderOptions;
    },
  },

  methods: {
    handleAddressSelectedBilling(i, address) {
      const suggestedStreetAddress = address.route;
      if (suggestedStreetAddress)
        this.form.billingAddresses[i][
          'street_address'
        ] = suggestedStreetAddress;

      const suggestedCountry = address.country;
      if (suggestedCountry) {
        const countryFound = this.countries.find(
          (x) => x.extra === suggestedCountry
        );
        if (countryFound)
          this.form.billingAddresses[i]['country'] = countryFound.value;
      }
      const suggestedCity = address.city;
      if (suggestedCity) this.form.billingAddresses[i]['city'] = suggestedCity;

      const suggestedPostalCode = address.postal_code;
      if (suggestedPostalCode)
        this.form.billingAddresses[i]['postal_code'] = suggestedPostalCode;

      const suggestedStreet = address.route;
      if (suggestedStreet)
        this.form.billingAddresses[i]['street_address'] = suggestedStreet;

      const suggestedState = address.province;
      if (suggestedState)
        this.form.billingAddresses[i]['state'] = suggestedState;

      const suggestedRegion = address.region;
      if (suggestedRegion)
        this.form.billingAddresses[i]['region'] = suggestedRegion;

      let suggestedStreetNumber = address.street_number;
      if (suggestedStreetNumber) {
        if (this.form.billingAddresses[i]['street_address']) {
          suggestedStreetNumber = ' ' + suggestedStreetNumber;
        }
        this.form.billingAddresses[i]['street_address'] =
          this.form.billingAddresses[i]['street_address'] +
          suggestedStreetNumber;
      }
    },
    handleAddressSelectedShipping(i, address) {
      const suggestedStreetAddress = address.route;
      if (suggestedStreetAddress)
        this.form.shippingAddresses[i][
          'street_address'
        ] = suggestedStreetAddress;

      const suggestedCountry = address.country;
      if (suggestedCountry) {
        const countryFound = this.countries.find(
          (x) => x.extra === suggestedCountry
        );
        if (countryFound)
          this.form.shippingAddresses[i]['country'] = countryFound.value;
      }
      const suggestedCity = address.city;
      if (suggestedCity) this.form.shippingAddresses[i]['city'] = suggestedCity;

      const suggestedPostalCode = address.postal_code;
      if (suggestedPostalCode)
        this.form.shippingAddresses[i]['postal_code'] = suggestedPostalCode;

      const suggestedStreet = address.route;
      if (suggestedStreet)
        this.form.shippingAddresses[i]['street_address'] = suggestedStreet;

      const suggestedState = address.province;
      if (suggestedState)
        this.form.shippingAddresses[i]['state'] = suggestedState;

      const suggestedRegion = address.region;
      if (suggestedRegion)
        this.form.shippingAddresses[i]['region'] = suggestedRegion;

      let suggestedStreetNumber = address.street_number;
      if (suggestedStreetNumber) {
        if (this.form.shippingAddresses[i]['street_address']) {
          suggestedStreetNumber = ' ' + suggestedStreetNumber;
        }
        this.form.shippingAddresses[i]['street_address'] =
          this.form.shippingAddresses[i]['street_address'] +
          suggestedStreetNumber;
      }
    },
    capitalizeWords(string) {
      return string.replace(/(?:^|\s)\S/g, function (a) {
        return a.toUpperCase();
      });
    },
    changedName(field, val) {
      this.$v.form[field].$model = this.capitalizeWords(val);
    },
    setDecimal(name, val) {
      val = val.replace('.', ''); // remove thousands
      val = val.replace(',', '.'); // replace comma by dot
      this.$v.form[name].$model = val;
      this.$v.form[name].$touch();
    },
    copyCustomerInfoIntoShipping(shippingIndex) {
      // let activeBillingTabIndex = this.$refs['billing-tabs'].currentTab;

      this.form.shippingAddresses[shippingIndex][
        'first_name'
      ] = this.form.first_name;
      this.form.shippingAddresses[shippingIndex][
        'last_name'
      ] = this.form.last_name;
      this.form.shippingAddresses[shippingIndex][
        'street_address'
      ] = this.form.street_address;
      this.form.shippingAddresses[shippingIndex][
        'postal_code'
      ] = this.form.postal_code;
      this.form.shippingAddresses[shippingIndex]['city'] = this.form.city;
      this.form.shippingAddresses[shippingIndex]['country'] = this.form.country;
    },
    copyCustomerInfoIntoBilling(billingIndex) {
      // let activeBillingTabIndex = this.$refs['billing-tabs'].currentTab;

      this.form.billingAddresses[billingIndex][
        'first_name'
      ] = this.form.first_name;
      this.form.billingAddresses[billingIndex][
        'last_name'
      ] = this.form.last_name;
      this.form.billingAddresses[billingIndex][
        'street_address'
      ] = this.form.street_address;
      this.form.billingAddresses[billingIndex][
        'postal_code'
      ] = this.form.postal_code;
      this.form.billingAddresses[billingIndex]['city'] = this.form.city;
      this.form.billingAddresses[billingIndex]['country'] = this.form.country;

      this.form.billingAddresses[billingIndex][
        'company_name'
      ] = this.form.company_name;
      this.form.billingAddresses[billingIndex][
        'company_id'
      ] = this.form.company_id;
    },
    closeTabBilling(i) {
      if ('id' in this.form.billingAddresses[i]) {
        actions.deleteBillingAddress(this.form.billingAddresses[i].id);
      }

      this.form.billingAddresses.splice(i, 1);
    },
    closeTabShipping(i) {
      if ('id' in this.form.shippingAddresses[i]) {
        actions.deleteShippingAddress(this.form.shippingAddresses[i].id);
      }

      this.form.shippingAddresses.splice(i, 1);
    },
    newTabBilling() {
      this.form.billingAddresses.push({
        name: 'contacto ' + this.form.billingAddresses.length,
        full_name: '',
        street_address: '',
        street_address_2: '',
        urbanization: '',
        postal_code: '',
        state: '',
        region: '',
        city: '',
        country: null,
        company_id: '',
      });

      let that = this;
      this.$nextTick(() => {
        that.$refs[
          'billing-address-' + (this.form.billingAddresses.length - 1)
        ][0].activate();
      });
    },
    newTabShipping() {
      this.form.shippingAddresses.push({
        name: 'contacto ' + this.form.shippingAddresses.length,
        full_name: '',
        street_address: '',
        street_address_2: '',
        urbanization: '',
        postal_code: '',
        state: '',
        region: '',
        city: '',
        country: null,
        phone_number_1: '',
        phone_number_2: '',
        email_1: '',
        email_2: '',
        person_of_contact: '',
      });

      let that = this;
      this.$nextTick(() => {
        that.$refs[
          'shipping-address-' + (this.form.shippingAddresses.length - 1)
        ][0].activate();
      });
    },

    validateStateBillingAddress(i, name) {
      const { $dirty, $error } = this.$v.form.billingAddresses.$each[i][name];
      return $dirty ? !$error : null;
    },

    validateStateShippingAddress(i, name) {
      const { $dirty, $error } = this.$v.form.shippingAddresses.$each[i][name];
      return $dirty ? !$error : null;
    },

    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        console.log('Validation error');
        console.log(this.$v.form);
        return;
      }

      store.setOverlayShow(true);

      let customerPromise = null;
      let shippingPromises = [];

      // Customer data
      let data = {};

      data['full_name'] = this.form.full_name;
      data['person_of_contact'] = this.form.person_of_contact;
      data['phone_number'] = this.form.phone_number;
      data[
        'phone_number_person_of_contact'
      ] = this.form.phone_number_person_of_contact;
      data['email'] = this.form.email;
      data['email_person_of_contact'] = this.form.email_person_of_contact;
      data['opted_in_commercial'] = this.form.opted_in_commercial;
      data['comms_lang'] = this.form.comms_lang;
      data['gender'] = this.form.gender;

      data['street_address'] = this.form.street_address;
      data['postal_code'] = this.form.postal_code;
      data['city'] = this.form.city;
      data['country'] = this.form.country;

      data['company_name'] = this.form.company_name;
      data['company_id'] = this.form.company_id;

      data['default_discount'] = this.form.default_discount;

      // edit
      Sentry.setExtra('data', JSON.stringify(data));

      if (this.id !== 'new') {
        customerPromise = actions.patchCustomer(this.id, data);
      } else {
        customerPromise = actions.postCustomer(data);
      }

      customerPromise
        .then((x) => {
          let customerID = x.data.id; // customer ID

          // Billing addresses
          for (
            let index = 0;
            index < this.form.billingAddresses.length;
            index++
          ) {
            const address = this.form.billingAddresses[index];

            let addressData = {};

            addressData['name'] = address['name'];
            addressData['full_name'] = address['full_name'];
            addressData['street_address'] = address['street_address'];
            addressData['street_address_2'] = address['street_address_2'];
            addressData['urbanization'] = address['urbanization'];
            addressData['state'] = address['state'];
            addressData['region'] = address['region'];

            addressData['postal_code'] = address['postal_code'];
            addressData['city'] = address['city'];
            addressData['country'] = address['country'];
            addressData['company_id'] = address['company_id'];
            addressData['customer'] = customerID;

            if (!('id' in address)) {
              // create new one

              shippingPromises.push(actions.postBillingAddress(addressData));
            } else {
              // update existing

              shippingPromises.push(
                actions.patchBillingAddress(address['id'], addressData)
              );
            }
          }

          // Shipping addresses
          for (
            let index = 0;
            index < this.form.shippingAddresses.length;
            index++
          ) {
            const address = this.form.shippingAddresses[index];

            let addressData = {};

            addressData['name'] = address['name'];
            addressData['full_name'] = address['full_name'];
            addressData['street_address'] = address['street_address'];
            addressData['street_address_2'] = address['street_address_2'];
            addressData['urbanization'] = address['urbanization'];
            addressData['postal_code'] = address['postal_code'];
            addressData['state'] = address['state'];
            addressData['region'] = address['region'];

            addressData['city'] = address['city'];
            addressData['country'] = address['country'];
            addressData['phone_number_1'] = address['phone_number_1'];
            addressData['phone_number_2'] = address['phone_number_2'];
            addressData['email_1'] = address['email_1'];
            addressData['email_2'] = address['email_2'];
            addressData['person_of_contact'] = address['person_of_contact'];

            addressData['customer'] = customerID;

            if (!('id' in address)) {
              // create new one

              shippingPromises.push(actions.postShippingAddress(addressData));
            } else {
              // update existing

              shippingPromises.push(
                actions.patchShippingAddress(address['id'], addressData)
              );
            }
          }

          Promise.all(shippingPromises).then((x) => {
            if (this.id === 'new') {
              this.$emit('customerAdded', customerID);
            }

            if (this.isModal) {
              store.setOverlayShow(false);
            } else {
              this.$router.push({ name: 'AdminCustomersScreen' });
            }
          });
        })
        .catch((err) => {
          store.setOverlayShow(false);
          if (err.response.status === 400) {
            const reason = err.response.data;
            if (reason.includes('ERROR_ALREADY_EXISTS')) {
              this.$notify({
                title: 'Error',
                type: 'error',
                text:
                  'Este cliente ya existe. Puedes usar su email para localizarlo, a través del buscador, en la página de listado de clientes.',
                duration: 10000,
              });
            }
          }
        });
    },
  },
  mounted() {},
};
</script>
